<template>
  <div>
    <Form :ref="'form'+current" :model="form" :rules="rules" :label-width="165">
      <Divider orientation="left">其他材料</Divider>
      <Row :gutter="16">
        <Col span="24">
        <FormItem label="补充说明" prop="supplementaryMaterialDescription">
          <Input v-model="form.supplementaryMaterialDescription" :rows="4" placeholder="请输入..." type="textarea" />
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem :label="'其他材料'" prop="supplementaryMaterialOtherFileGuidList">
          <Upload ref="supplementaryMaterialOtherFileGuidList" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :show-upload-list="false" :default-file-list="form.supplementaryMaterialOtherFileGuidListPreview"
            style="flex:1;" :on-preview="handlePreview" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, 'supplementaryMaterialOtherFileGuidList',true)"
            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'supplementaryMaterialOtherFileGuidList',true)" :on-format-error="handleFormatError">
            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
            <Button icon="ios-camera" @click.stop="openQrCodeUpload('supplementaryMaterialOtherFileGuidList',true)">手机拍照上传</Button>
          </Upload>
          <div class="_linkdel" v-for="file in form.supplementaryMaterialOtherFileGuidListPreview" :key="file.guid">
            <div class="fileCentent" @click="handlePreview(file)">
              <Icon :type="file.name | fileType" />
              {{file.name?file.name:file.fileName}}
            </div>
            <div class="fileDel">
              <Icon type="md-close" @click="handleRemove(file, null, 'supplementaryMaterialOtherFileGuidList',true)" />
            </div>
          </div>
        </FormItem>
        </Col>

      </Row>

      <div class="bom_btn">
        <div>
          <Button @click="next(null,-1)">上一步</Button>
          <Button type="primary" @click="next('form'+current,1)">下一步</Button>
        </div>
      </div>
    </Form>

  </div>
</template>
<script>
export default {
  props: { form: { type: Object }, current: { type: Number } },
  data() {
    return {
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      count: 0, //操作
      uploadData: {},
      QRshow: false,
      loading: false,
      timer: null,
      appInfoDataType: this.$store.state.appInfoDataType,
      current_index: this.current,
      rules: {
        supplementaryMaterialDescription: [
          {
            required:
              this.form.applicationType != this.$store.state.applicationType['居住证积分续办'],
            message: '请输入',
            trigger: 'change',
          },
        ],
        supplementaryMaterialOtherFileGuidList: [
          {
            required:
              this.form.applicationType != this.$store.state.applicationType['居住证积分续办'],
            type: 'array',
            message: '请上传',
            trigger: 'change',
          },
        ],
      },
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  methods: {
    //下一步
    next(name, val) {
      //上一步
      let _this = this
      let submiteUrl = '/api/services/app/JZZJFApi/SaveSupplementaryMaterialInfo'

      if (name == null) {
        this.$emit('next', val, submiteUrl)
        return
      }
      //下一步

      this.$refs[name].validate((valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        //个人申请--提交到单位
        //单位申请--扫码提交
        if (this.$store.state.isPerson) {
          this.$emit('submit', submiteUrl, 0, '', true, (res) => {
            if (res == true) {
              _this.$emit(
                'submit',
                '/api/services/app/JZZJFApi/SubmitApplicationByPerson',
                1,
                '提交成功'
              )
            }
          })
        } else {
          _this.$emit('next', val, submiteUrl)
        }
      })
    },
    openQrCodeUpload(property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit('openQrCodeUpload', property, isArray, isReadInfo, readIdInfoAfterToView)
    },
    // submit(name) {
    //   let _this = this
    //   this.$refs[name].validate((valid) => {
    //     if (!valid) {
    //       this.$Message.error('请将信息填写完整')
    //       return
    //     }
    //     this.$Modal.confirm({
    //       title: '请确认',
    //       content: `<p>是否提交信息</p>`,
    //       okText: '是',
    //       cancelText: '否',
    //       onOk: () => {
    //         _this.$emit('submit')
    //       },
    //     })
    //   })
    // },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(
      response,
      file,
      fileList,
      property,
      isArray,
      isReadIdInfoAfter,
      readIdInfoAfterToView
    ) {
      this.$emit(
        'handleSuccess',
        response,
        file,
        fileList,
        property,
        isArray,
        isReadIdInfoAfter,
        readIdInfoAfterToView
      )
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
    //预览
    handleView(guid) {
      this.$emit('handleView', guid)
    },
    //
    updateProgress(event, file, fileList, name) {
      // this.percent = fileInfo.percent * 0.01
      this.$refs[name + 'Upload'].style.display = 'none'
      this.$refs[name].updateShow(true)
      this.$refs[name].updateProgress(Math.round(event.percent)) //=fileInfo.percent * 0.01

      this.$refs[name + 'Upload'].show = event.percent == 100
      // if (event.percent == 100) {
      //   this.$refs[name].updateShow(false)
      //   this.$refs[name + 'Upload'].style.display = 'block'
      // }
    },
  },
}
</script>
